import { Children, ReactNode } from 'react';

export const areShallowEqual = (
    prevProps: Record<string, any>,
    nextProps: Record<string, any>
): boolean => {
    return (
        prevProps.length === nextProps.length &&
        Object.keys(prevProps).every((k) => prevProps[k] === nextProps[k])
    );
};

export const isChildPresent = (children: ReactNode): boolean => {
    return !!Children.toArray(children).length;
};

export const extractTextFromElement = (
    element: JSX.Element | string | number
): string => {
    // Check if the element is a string or number and return as is
    if (typeof element === 'string' || typeof element === 'number') {
        return element.toString();
    }

    // If the element is an array, concatenate the text content of each element
    if (Array.isArray(element)) {
        return element.map(extractTextFromElement).join(' ');
    }

    // If the element has props and children, recurse on the children
    if (element.props?.children) {
        return extractTextFromElement(element.props.children);
    }

    return '';
};
